import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, Legend, CartesianGrid } from "recharts";
import ChartFrame from "@/components/ChartFrame";
import { TrendingUp } from "lucide-react";
import { CHART_MARGIN, TOOLTIP_STYLE, TICK_AXIS, LEGEND_STYLE, DOT_SM, INIT_DIM_LG } from "@/lib/chartStyles";

const TRACK_PALETTE = ["#6C8EBF", "#5d8a73", "#b07d3a", "#9A7AA0", "#C97064", "#4A5D6B", "#3f7a5c"];

export default function ProgressTracker({ records }) {
  if (!records || records.length === 0) return null;
  const sorted = [...records].sort((a, b) => (a.date < b.date ? -1 : a.date > b.date ? 1 : 0));
  const names = [...new Set(sorted.map((r) => r.template_name))];
  const byDate = {};
  const order = [];
  sorted.forEach((r) => {
    const d = new Date(r.date).toLocaleDateString("en-IE", { day: "numeric", month: "short" });
    if (!byDate[d]) { byDate[d] = { date: d }; order.push(d); }
    byDate[d][r.template_name] = r.total ? Math.round((r.score / r.total) * 100) : 0;
  });
  const data = order.map((d) => byDate[d]);

  return (
    <div className="bg-white rounded-2xl border border-slate-100 shadow-[0_4px_24px_rgba(42,59,71,0.04)] p-6" data-testid="running-progress-tracker">
      <h3 className="font-['Outfit'] text-lg font-bold text-slate-800 flex items-center gap-2 mb-1">
        <TrendingUp size={20} className="text-[#5d8a73]" /> Progress tracker
      </h3>
      <p className="text-sm text-slate-400 mb-4">Percentage known over time across every running-assessment list.</p>
      <ChartFrame className="h-64 -ml-2">
        <ResponsiveContainer width="100%" height="100%" minWidth={1} minHeight={1} initialDimension={INIT_DIM_LG}>
          <LineChart data={data} margin={CHART_MARGIN}>
            <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" vertical={false} />
            <Tooltip contentStyle={TOOLTIP_STYLE} />
            <XAxis dataKey="date" tick={TICK_AXIS} axisLine={false} tickLine={false} />
            <YAxis domain={[0, 100]} tick={TICK_AXIS} axisLine={false} tickLine={false} width={30} unit="%" />
            <Legend wrapperStyle={LEGEND_STYLE} />
            {names.map((n, i) => (
              <Line key={n} type="monotone" dataKey={n} stroke={TRACK_PALETTE[i % TRACK_PALETTE.length]}
                strokeWidth={2.5} dot={DOT_SM} connectNulls />
            ))}
          </LineChart>
        </ResponsiveContainer>
      </ChartFrame>
    </div>
  );
}
